import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const reliaQuestGreyMatter = defineConnector({
  identifier: "reliaQuestGreyMatter",
  name: "ReliaQuest GreyMatter",
  tagLine: "Threat detection, investigation, and response",
  keywords: "reliaquest grey matter cybersecurity incidents graphql",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () =>
    "https://greymatter\\.myreliaquest\\.com/graphql(?:\\?.*)?$",
  auth: (app) => headerAuth([{ name: "X-API-KEY", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [GreyMatter](https://greymatter.myreliaquest.com), open **Settings → API Key Management → New API Key**. Choose an expiration date, click **Create Key**, and copy the key when it appears. Creating a new key invalidates your previous key. See the [API documentation](https://apidocs.myreliaquest.com/).",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://greymatter.myreliaquest.com/graphql",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: "{ me { id } }" }),
      expectedBodyContains: '"id"',
    }),
  },
});
